import { useAppDispatch } from 'app/hooks'
import { CountType, InsightViewOption } from 'enums'
import { getWidgetForDashboard } from 'features/widget/asyncThunks'
import { useDashboardData, useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { useEffect } from 'react'
import { Dashboard } from 'schemas/DashboardSchema'
import { createInsightCount } from 'utils/runSearchUtil'
import { toFilter, deriveCountType } from 'utils/widgetUtil'
import { getInsightCategory } from 'utils/viewOptionUtil'
import { WidgetId } from 'features/types'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'
import Measure from 'enums/Measure'

import { UsageAndAttitudeWidgetType } from '../types'

const createSearches = (widgetSetting: UsageAndAttitudeWidgetType, dashboardData: Dashboard) => {
  const { precision, viewOption, selectedTopic, topN } = widgetSetting

  const firstLevelSize =
    widgetSetting.viewOption === InsightViewOption.EMOTIONS_BEHAVIORS_TO_THINGS ? topN! / 2 : topN

  const filter = toFilter(widgetSetting)
  const topicIds = [selectedTopic.topicId!]
  const { id: dashboardId, name } = dashboardData
  const measure = Measure.POSTS

  const insightCountOption = {
    multipleLevelSizeNeeded: [firstLevelSize, 20],
    isAuthorBased: deriveCountType(widgetSetting) === CountType.AUTHORS
  }

  return createInsightCount(
    dashboardId!,
    name!,
    precision!,
    topicIds,
    filter,
    measure!,
    getInsightCategory(viewOption!),
    insightCountOption
  )
}

const RunSearchEffect = ({
  widgetId,
  children
}: {
  widgetId: WidgetId
  children: React.ReactElement
}) => {
  const widgetSetting = useDashboardWidgetSetting<UsageAndAttitudeWidgetType>(widgetId)
  const dashboardData = useDashboardData()
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const searches = createSearches(widgetSetting, dashboardData!)

    dispatch(
      getWidgetForDashboard({
        searches: [searches],
        widgetId: widgetSetting.widgetId!,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardData, dispatch, refreshTimestamp])

  return children
}

export default RunSearchEffect
